import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EstimatedCIFPage from "@/pages/EstimatedCIFPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EstimatedCIFPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
